/**
 * 客户列表
 */
import { CUSTOMERLIST } from '../types';

export default {
    name: `${CUSTOMERLIST}`,
    path: '/customerList',
    component: () => import(/* webpackChunkName: 'customerList' */ '@/views/customerList/'),
    redirect: { name: `${CUSTOMERLIST}Index` },
    meta: {
        title: '客户列表',
        // 页签缓存的滚动条位置
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${CUSTOMERLIST}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'customerList' */ '@/views/customerList/home/Home.vue'),
        },
        {
            name: `${CUSTOMERLIST}Detail`,
            path: 'detail/:id',
            component: () => import(/* webpackChunkName: 'customerList' */ '@/views/customerList/detail/Detail.vue'),
        },
    ],
};
